<template>
  <div class="scene_add">
    <div class="left">
      <scene-round :device="b" v-for="b in devices" :key="`colorbar_${b.name}`" @change="(c)=>{b.checked=c}">
        <img :src="require('../../assets/images/device/light/device_colorbar_e.png')" style="width:60px " slot="icon"/>
        <div class="pd20">
          <el-form label-width="60px">
            <el-form-item label="开关：">
              <div class="text-right">
                <img :src="getIcon(b.state)" class="pointer" style="width: 80px" @click="b.state=!b.state"/>
              </div>
            </el-form-item>
            <el-form-item label="颜色：">
            </el-form-item>
            <div class="bt-group">
              <div @click="change(b,'red')">
                <span class="radius" mode1 :selected="b.color==='red'"></span>
                <span>红色</span>
              </div>
              <div @click="change(b,'green')">
                <span class="radius" mode2 :selected="b.color==='green'"></span>
                <span>绿色</span>
              </div>
              <div @click="change(b,'blue')">
                <span class="radius" mode3 :selected="b.color==='blue'"></span>
                <span>蓝色</span>
              </div>
              <div @click="change(b,'yellow')">
                <span class="radius" mode4 :selected="b.color==='yellow'"></span>
                <span>黄色</span>
              </div>
              <div @click="change(b,'deepskyblue')">
                <span class="radius" mode5 :selected="b.color==='deepskyblue'"></span>
                <span>青色</span>
              </div>
              <div @click="change(b,'deeppink')">
                <span class="radius" mode6 :selected="b.color==='deeppink'"></span>
                <span>粉色</span>
              </div>
              <div @click="change(b,'white')">
                <span class="radius" mode7 :selected="b.color==='white'"></span>
                <span>白色</span>
              </div>
              <div @click="change(b,'color')">
                <img src="../../assets/images/device/light/d-zdy.png" :selected="b.color==='color'"/>
                <span>变换</span>
              </div>
              <div class="empty">
                <span class="radius" mode6 :selected="b.color==='deeppink'"></span>
                <span>粉色</span>
              </div>
            </div>
          </el-form>
        </div>
      </scene-round>
    </div>
    <div class="right">
      <el-form label-width="60px">
        <el-form-item label="开关：">
          <div class="text-right">
            <img :src="getIcon(device.state)" class="pointer" style="width: 80px" @click="device.state=!device.state"/>
          </div>
        </el-form-item>
        <el-form-item label="颜色：">
        </el-form-item>
        <div class="bt-group">
          <div @click="change(device,'red')">
            <span class="radius" mode1 :selected="device.color==='red'"></span>
            <span>红色</span>
          </div>
          <div @click="change(device,'green')">
            <span class="radius" mode2 :selected="device.color==='green'"></span>
            <span>绿色</span>
          </div>
          <div @click="change(device,'blue')">
            <span class="radius" mode3 :selected="device.color==='blue'"></span>
            <span>蓝色</span>
          </div>
          <div @click="change(device,'yellow')">
            <span class="radius" mode4 :selected="device.color==='yellow'"></span>
            <span>黄色</span>
          </div>
          <div @click="change(device,'deepskyblue')">
            <span class="radius" mode5 :selected="device.color==='deepskyblue'"></span>
            <span>青色</span>
          </div>
          <div @click="change(device,'deeppink')">
            <span class="radius" mode6 :selected="device.color==='deeppink'"></span>
            <span>粉色</span>
          </div>
          <div @click="change(device,'white')">
            <span class="radius" mode7 :selected="device.color==='white'"></span>
            <span>白色</span>
          </div>
          <div @click="change(device,'color')">
            <img src="../../assets/images/device/light/d-zdy.png" :selected="device.color==='color'"/>
            <span>变换</span>
          </div>
          <div class="empty">
            <span class="radius" mode6 :selected="device.color==='deeppink'"></span>
            <span>粉色</span>
          </div>
        </div>
      </el-form>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import SceneRound from './Round'
import api from '../../model/device'
import comm from '../../assets/lib/comm'

export default {
  name: 'SceneColorbar',
  props: {
    command: {
      type: Array,
      default () {
        return []
      }
    }
  },
  data () {
    return { device: { state: 1, color: 'white' }, copy: {}, devices: [] }
  },
  computed: {
    ...mapState(['extDevices', 'extDevicesOrign'])
  },
  components: {
    SceneRound
  },
  watch: {
    extDevices () {
      this.devices = this.extDevices.filter(d => d.devicetype.key === 'colorbar').map(d => {
        return { deviceId: d.deviceId, name: d.name, sid: d.sid, nd: d.nd, ...this.device, checked: false, cmd: { ...d.cmd } }
      })
      this.syncCommand()
    },
    device: {
      deep: true,
      handler () {
        this.devices.forEach(b => {
          for (const key in this.device) {
            if (this.device[key] !== this.copy[key]) {
              b[key] = this.device[key]
            }
          }
        })
        this.copy = { ...this.device }
      }
    }
  },
  created () {
    this.devices = this.extDevices.filter(d => d.devicetype.key === 'colorbar').map(d => {
      return { deviceId: d.deviceId, name: d.name, sid: d.sid, nd: d.nd, ...this.device, checked: false, cmd: { ...d.cmd } }
    })
    this.copy = { ...this.device }
    this.$hub.$on('getCommand', this.reportCommand)
  },
  mounted () {
    // 同步一次命令
    this.syncCommand()
  },
  deactivated () {
    this.reportCommand()
  },
  methods: {
    getIcon (state) {
      if (state) {
        return require('../../assets/images/home/open.png')
      } else {
        return require('../../assets/images/home/close.png')
      }
    },
    change (device, color) {
      device.color = color
    },
    syncCommand () {
      this.command.forEach(c => {
        // 同步命令至当前模板
        if (this.devices.map(b => b.nd).includes(c.nd)) {
          const devices = this.devices.filter(b => b.nd === c.nd)
          devices.forEach(device => {
            device.checked = true
            // 找到匹配项之后，开始解析支持的命令
            const actions = JSON.parse(device.cmd.action)
            // 找到命令中包含的动作
            Object.keys(actions).forEach(name => {
              if (comm.containObject(c, actions[name])) {
                // 包含了指定的动作，那么该动存在，需要将其转换为对应的属性并进行赋值
                const obj = this.$parent.resolveAction(name, true)
                device[obj.key] = obj.value
              }
            })
          })
        }
      })
    },
    reportCommand () {
      // 同步数据
      const command = []
      this.devices.filter(d => d.checked).forEach(b => {
        // 对于多控制器的特殊处理
        let obj = this.extDevicesOrign.filter(item => item.nd === b.nd && item.deviceId !== b.deviceId)
        if (obj && obj.length) {
          obj.forEach(item => {
            command.push(Object.assign(api.generateCommand(b, b.state ? b.color : 'close'), { deviceId: item.deviceId }))
          })
        } else {
          command.push(Object.assign(api.generateCommand(b, b.state ? b.color : 'close'), { deviceId: b.deviceId }))
        }
        // if (b.state) {
        //   command.push(Object.assign(api.generateCommand(b, b.color), { deviceId: b.deviceId }))
        // } else {
        //   command.push(Object.assign(api.generateCommand(b, 'close'), { deviceId: b.deviceId }))
        // }
      })
      // debugger
      this.$emit('changeCommand', command, this.devices.filter(d => !d.checked).map(d => {
        return { deviceId: d.deviceId, nd: d.nd, sid: d.sid }
      }))
    }
  }
}
</script>

<style scoped lang="less">
.scene_add {
  margin-top: 20px;
  background: rgba(255, 255, 255, 1);
  border-radius: 4px;
  flex: 1;
  display: flex;
  flex-direction: row;
  padding: 0px 20px 0px 20px;
  .radius {
    display: inline-block;
    width: 45px;
    height: 45px;
    cursor: pointer;
    border-radius: 50%;
    margin-bottom: 10px;
  }

  .radius[selected] {
    width: 41px;
    height: 41px;
    border: 2px solid #b7bbbf;
  }

  .radius[mode1] {
    background: red;
  }
  .radius[mode2] {
    background: green;
  }
  .radius[mode3] {
    background: blue;
  }
  .radius[mode4] {
    background: yellow;
  }
  .radius[mode5] {
    background: cyan;
  }
  .radius[mode6] {
    background: deeppink;
  }
  .radius[mode7] {
    background: #E0E0E0;
  }
  & .bt-group {
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
    text-align: center;
    font-size: 12px;
    font-weight: 400;
    color: rgba(89, 89, 89, 1);
    margin-top: -20px;
    > div {
      width: 33%;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      margin-bottom: 10px;
    }
    & img {
      margin-bottom: 10px;
      width: 45px;
      border-radius: 50%;
    }
    & img[selected] {
      width: 41px;
      border: 2px solid #b7bbbf;
    }
  }
  > .left {
    flex: 1;
    padding-right: 30px;
    padding-top: 20px;
    width: 0;
    height: 100%;
    overflow-y: auto;
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    align-items: flex-start;
    align-content: flex-start;
    .pd20 {
      padding: 0px 20px;
    }
  }
  > .right {
    overflow-y: auto;
    padding-top: 20px;
    padding-left: 20px;
    width: 300px;
    border-left: 1px solid #DFE1E5;
    & .form {
      display: flex;
    }
  }
}
</style>
